"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.paypalShortLabelFromComment = exports.formatPaypalReservationComment = void 0;
function formatPaypalReservationComment(transactionId, kind) {
    const tx = `Transaction ${transactionId}`;
    if (kind === 'apple_pay') {
        return `Moyen de paiement : PayPal (Apple Pay), ${tx}`;
    }
    if (kind === 'google_pay') {
        return `Moyen de paiement : PayPal (Google Pay), ${tx}`;
    }
    return `Moyen de paiement : PayPal, ${tx}`;
}
exports.formatPaypalReservationComment = formatPaypalReservationComment;
function paypalShortLabelFromComment(comments, lang) {
    if (/PayPal \(Apple Pay\)/i.test(comments)) {
        return lang === 'fr' ? 'PayPal (Apple Pay)' : 'PayPal (Apple Pay)';
    }
    if (/PayPal \(Google Pay\)/i.test(comments)) {
        return lang === 'fr' ? 'PayPal (Google Pay)' : 'PayPal (Google Pay)';
    }
    return lang === 'fr' ? 'PayPal' : 'PayPal';
}
exports.paypalShortLabelFromComment = paypalShortLabelFromComment;
//# sourceMappingURL=paypalLabels.js.map